import React, { ReactNode } from 'react';
import PropTypes from 'prop-types';

interface CardProps {
  children: ReactNode;
  className?: string;
  square?: boolean;
  outline?: boolean;
  [key: string]: any; // To allow additional props
}

function Card({ children, className, square, outline, ...props }: CardProps) {
  const baseClass = `shadow-sm 
  border-border_gray_200
  rounded-[10px] 
  hover:shadow-md 
  ${className?.includes('border-') ? '' : 'border-2'}
  ${className?.includes('hover:opacity-') ? '' : 'hover:opacity-95'}
  ${className?.includes('bg-') ? '' : 'bg-surface_gray_25_hover'}
  ${className?.includes('p-') ? '' : 'p-5'}`;
  const squareClass = square ? 'w-64 h-48' : '';
  const outlineClass = outline ? 'border border-border_gray_200' : '';
  return (
    <div className={`${baseClass} ${squareClass} ${outlineClass} ${className}`} {...props}>
      {children}
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Card;
